// const moment = require('moment')

const baseRow = [
  {
    span: 12,
    label: '产品名称',
    component: 'AInput',
    placeholder: '请输入产品名称',
    prop: 'title',
    allowClear: true
  },
  {
    span: 10,
    label: '产品类型',
    component: 'ASelect',
    prop: 'financialType',
    placeholder: '请选择产品类型',
    list: [
      { label: '金融机构', value: '1' },
      { label: '商业银行', value: '2' },
      { label: '担保公司', value: '3' },
      { label: '保险公司', value: '4' }
    ]
  },
  {
    span: 24,
    label: '配图',
    component: 'AUpload',
    prop: 'picPath' // 首图
  },
  {
    span: 24,
    label: '产品描述',
    component: 'ATextArea',
    placeholder: '请输入产品描述',
    prop: 'content'
  },
  {
    span: 24,
    label: '附件',
    component: 'AUploadMultiple',
    prop: 'annexIds'
  }
]

const richOpt = [
  {
    span: 24,
    label: '标题1',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: '1-section'
  },
  {
    span: 24,
    label: '内容1',
    component: 'RichTextEdit',
    prop: '1-content'
  },
  {
    span: 24,
    label: '标题2',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: '2-section'
  },
  {
    span: 24,
    label: '内容2',
    component: 'RichTextEdit',
    prop: '2-content'
  },
  {
    span: 24,
    label: '标题3',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: '3-section'
  },
  {
    span: 24,
    label: '内容3',
    component: 'RichTextEdit',
    prop: '3-content'
  },
  {
    span: 24,
    label: '标题4',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: '4-section'
  },
  {
    span: 24,
    label: '内容4',
    component: 'RichTextEdit',
    prop: '4-content'
  },
  {
    span: 24,
    label: '标题5',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: '5-section'
  },
  {
    span: 24,
    label: '内容5',
    component: 'RichTextEdit',
    prop: '5-content'
  },
  {
    span: 24,
    label: '标题6',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: '6-section'
  },
  {
    span: 24,
    label: '内容6',
    component: 'RichTextEdit',
    prop: '6-content'
  }
]

const formRules = {
  title: [
    { required: true, message: '产品名称不能为空', trigger: 'blur' },
    { min: 1, max: 100, message: '输入的字数不能超过100个', trigger: 'blur' }
  ],
  picPath: [{ required: true, message: '配图不能为空', trigger: ['blur'] }],
  financialType: [
    { required: true, message: '产品类型不能为空', trigger: ['blur'] }
  ],
  issueDate: [
    { required: true, message: '发布日期不能为空', trigger: ['blur'] }
  ]
  // content: [
  //   { required: true, message: '产品描述不能为空', trigger: ['blur'] }
  // ],
  // annexlds: [
  //   { required: true, message: '附件不能为空', trigger: ['blur'] }
  // ],
  // sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
}

const formRows = baseRow.concat(richOpt)

const formInfo = [
  { label: '产品名称', value: '-', key: 'title' },
  { label: '产品类型', value: '-', key: 'financialTypeStr' },
  { label: '配图', value: '-', key: 'picture', isVHtml: true },
  { label: '产品描述', value: '-', key: 'content' },
  { label: '附件', value: '-', key: 'annex', isVHtml: true },
  { label: '标题1', value: '-', key: 'section1' },
  { label: '内容1', value: '-', key: 'content1', isVHtml: true },
  { label: '标题2', value: '-', key: 'section2' },
  { label: '内容2', value: '-', key: 'content2', isVHtml: true },
  { label: '标题3', value: '-', key: 'section3' },
  { label: '内容3', value: '-', key: 'content3', isVHtml: true },
  { label: '标题4', value: '-', key: 'section4' },
  { label: '内容4', value: '-', key: 'content4', isVHtml: true },
  { label: '标题5', value: '-', key: 'section5' },
  { label: '内容5', value: '-', key: 'content5', isVHtml: true },
  { label: '标题6', value: '-', key: 'section6' },
  { label: '内容6', value: '-', key: 'content6', isVHtml: true }
]

module.exports = {
  formRows,
  formRules,
  richOpt,
  formInfo
}
